import React, { createContext, useState, useMemo } from "react";
import { node } from "prop-types";

const initialState = {
  page: "pageList",
  refetch: false,
  pageList: {
    data: [],
  },
  types: {},
  options: { dialog: false },
  addUpdate: {
    data: [
      {
        company: "",
        code:"",
        serino: "",       
        product: "",
        dimensions: "",
        productPalace: "",
        productDate: "",
        description: "",
      },
    ],
  },
  multipleAdd: {
    data: [],
  },
};

export const ConfirmContext = createContext(initialState);

export function ConfirmStore({ children }) {
  const [state, setState] = useState(initialState);
  const providerState = useMemo(() => ({ state, setState }), [state, setState]);
  return (
    <ConfirmContext.Provider value={providerState}>
      {children}
    </ConfirmContext.Provider>
  );
}

ConfirmStore.defaultProps = {
  children: null,
};

ConfirmStore.propTypes = {
  children: node,
};
